module.exports = __webpack_public_path__ + "img/168.89937de5.png";